export class PrintSizeChange {
  private static _category?: string;
  static get category() {
    const result = this._category;
    this._category = undefined;
    return result;
  }

  static set category(categoryId: string | undefined) {
    this._category = categoryId;
  }
}